var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "575DAF9B-440A-4164-A347-262B2B328D5C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paslaug\\u0173-s\\u0105ra\\u0161as-B",
    transform: "translate(-200.000000, -569.000000)",
    fill: "#27282A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(165.000000, 540.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5147186,32.6161165 C43.2010101,27.929825 50.7989899,27.929825 55.4852814,32.6161165 C59.9665401,37.0973753 60.1626024,44.2411138 56.0734681,48.9553481 L60.9422989,53.7757631 C61.1928793,54.0238959 61.2155799,54.41517 61.0091227,54.6892163 L60.9422989,54.7657007 C60.6698801,55.0381195 60.2285371,55.0392025 59.9547846,54.768124 L55.0968815,49.9583618 C50.3881732,54.2695098 43.0736549,54.1456156 38.5147186,49.5866793 C33.8284271,44.9003878 33.8284271,37.302408 38.5147186,32.6161165 Z M39.5046681,33.606066 C35.3651106,37.7456235 35.3651106,44.4571723 39.5046681,48.5967298 C43.6442256,52.7362873 50.3557744,52.7362873 54.4953319,48.5967298 C58.6348894,44.4571723 58.6348894,37.7456235 54.4953319,33.606066 C50.3557744,29.4665085 43.6442256,29.4665085 39.5046681,33.606066 Z",
    id: "search"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b46c68e27e2250dcca7862003fe26fcf.svg";
export { ForwardRef as ReactComponent };